import { IndicatorButtonSkeleton } from '@app/components/atoms/indicator-button/indicator-button-skeleton';

export const ListingFiltersSkeletonMobile = () => <IndicatorButtonSkeleton />;
